import { Box, Button, Divider, NoticeBox } from '@factorialco/deprecated-design-system'
import {
  BreakConfigurationFragment,
  TimePlanningPlannedBreakBreakTypeEnum as BreakType,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

import Item from './Item'

interface Props {
  plannedBreakForms: PlannedBreakForm[]
  validationParams: {
    startAt?: moment.Moment
    endAt?: moment.Moment
    duration?: number
  }
  onDelete: (form: PlannedBreakForm) => void
  onAddBreak: (breakConfiguration: BreakConfigurationFragment, breakType: BreakType) => void
}

const PlannedBreaks = ({ plannedBreakForms, validationParams, onDelete, onAddBreak }: Props) => {
  return (
    <>
      {plannedBreakForms.map((plannedBreakForm, index) => {
        if (plannedBreakForm.get('break_configuration.archived').value) {
          return (
            <Box key={index} flexDirection="row" gap="s64" alignItems="center">
              <NoticeBox
                message={i18n.t('shift_management.planned_breaks.archived.warning')}
                borderRadius={{ all: 'abs008' }}
              />
              <Button
                type="secondary"
                onClick={() => onDelete(plannedBreakForm)}
                iconName="delete"
              />
            </Box>
          )
        }

        const error = plannedBreakForm.validationError(validationParams)

        return (
          // FIXME: We shouldn't be using indexes as keys, but can't use id as key since new forms won't have one :_D
          <Box key={index} gap="s16">
            <Divider />
            <Item
              onAddBreak={onAddBreak}
              onDelete={onDelete}
              form={plannedBreakForm}
              error={error}
            />
          </Box>
        )
      })}
    </>
  )
}
export default observer(PlannedBreaks)
